import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Download, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { getToken } from '../../services/tokenService';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ Authorization: `Bearer ${getToken()}` });
const frDT = (iso) => (iso ? new Date(iso).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' }) : '—');
const eur = (v) => (v || v === 0 ? `${Number(v).toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €` : '—');
const LIBELLE_TYPE = { annuel: 'RCDS BATICO ANNUELLE', nominative: 'RCDS BATICO NOMINATIVE', par_periode: 'RCDS BATICO NOMINATIVE' };

const ouvrirDevis = async (id) => {
  try {
    const r = await axios.get(`${API}/souscriptions/simulateur/download-devis/${id}`, { headers: auth(), responseType: 'blob' });
    window.open(URL.createObjectURL(r.data), '_blank');
  } catch { toast.error('Devis introuvable'); }
};

/** Administration : devis où le bloc Adhésion partenaire (200 €) a été désactivé par un super admin. */
export default function DerogationsFtpe() {
  const [f, setF] = useState({ motif: '', mois: '' });
  const [data, setData] = useState(null);
  const charger = useCallback(() => {
    setData(null);
    axios.get(`${API}/maitres-ouvrage/derogations-ftpe`, { headers: auth(), params: f })
      .then((r) => setData(r.data)).catch(() => setData({ derogations: [], total: 0 }));
  }, [f]);
  useEffect(() => { charger(); }, [charger]);

  return (
    <div className="space-y-4" data-testid="derogations-ftpe">
      <div>
        <h2 className="text-lg font-bold text-[#0a3d62]">Dérogations adhésion partenaire</h2>
        <p className="text-sm text-slate-500">Devis générés avec le bloc Adhésion partenaire (200 €) désactivé, avec motif et auteur.</p>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <select value={f.motif} onChange={(e) => setF((x) => ({ ...x, motif: e.target.value }))} className="h-9 rounded-md border border-slate-200 px-2 text-sm" data-testid="derogations-filtre-motif">
          <option value="">Tous les motifs</option>
          <option value="deja_adherent">Déjà adhérent</option>
          <option value="adhesion_ulterieure">Adhésion ultérieure</option>
        </select>
        <input type="month" value={f.mois} onChange={(e) => setF((x) => ({ ...x, mois: e.target.value }))} className="h-9 rounded-md border border-slate-200 px-2 text-sm" data-testid="derogations-filtre-mois" />
        {data && <span className="text-xs text-slate-500" data-testid="derogations-total">{data.total} dérogation(s)</span>}
      </div>
      {!data ? <Loader2 className="h-5 w-5 animate-spin text-slate-400" /> : (
        <div className="overflow-x-auto rounded-xl border border-slate-200">
          <table className="w-full min-w-[900px] text-sm">
            <thead className="bg-slate-50 text-left text-xs text-slate-500">
              <tr><th className="p-2">Date</th><th className="p-2">Membre</th><th className="p-2">Devis</th><th className="p-2">Dispositif</th>
                <th className="p-2">Montant TTC</th><th className="p-2">Motif</th><th className="p-2">Auteur</th></tr>
            </thead>
            <tbody>
              {data.derogations.map((d) => (
                <tr key={d.id} className="border-t border-slate-100" data-testid={`derogation-${d.id}`}>
                  <td className="whitespace-nowrap p-2">{frDT(d.at)}</td>
                  <td className="p-2"><b>{d.raison_sociale || '—'}</b><div className="text-xs text-slate-400">{d.siret}</div></td>
                  <td className="p-2">
                    <button type="button" onClick={() => ouvrirDevis(d.devis_id)} className="inline-flex items-center gap-1 font-mono text-xs text-[#0a3d62] hover:underline" data-testid={`derogation-devis-${d.id}`}>
                      <Download className="h-3.5 w-3.5" /> {d.devis_id}
                    </button>
                  </td>
                  <td className="p-2 text-xs">{LIBELLE_TYPE[d.type_souscription] || d.type_souscription || '—'}</td>
                  <td className="p-2">{eur(d.montant_ttc)}</td>
                  <td className="p-2"><span className={`rounded px-2 py-0.5 text-xs font-semibold ${d.motif === 'deja_adherent' ? 'bg-emerald-100 text-emerald-800' : 'bg-amber-100 text-amber-800'}`}>{d.libelle}</span></td>
                  <td className="p-2 text-xs text-slate-500">{d.par}</td>
                </tr>
              ))}
              {!data.derogations.length && <tr><td colSpan={7} className="p-6 text-center text-slate-400">Aucune dérogation</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
